import Link from 'next/link';
import { useRouter } from 'next/router';

import { IFacetOption } from 'shared/types/ConstructorFacet';
import { getFiltersQuery } from 'search/utils/getFiltersQuery';
import { getCrawlerFiltersLinkHref } from 'search/utils/getCrawlerFiltersLinkHref';

interface ISearchFilterLink {
  children: React.ReactNode;
  facetType: string;
  option: IFacetOption;
  isCrawler?: boolean;
}

export const SearchFilterLink = ({
  children,
  facetType,
  option,
  isCrawler = false,
}: ISearchFilterLink) => {
  const { pathname, query } = useRouter();

  return (
    <Link
      href={
        isCrawler
          ? getCrawlerFiltersLinkHref({ pathname, query, option, facetType })
          : {
              pathname,
              query: getFiltersQuery(query, facetType, option),
            }
      }
      key={option.display_name}
      passHref
      prefetch={false}
      scroll
      shallow
      legacyBehavior
    >
      {children}
    </Link>
  );
};
